import axios from 'axios';
import endpoints from '@/api/endpoints';
import projectServices from '@/modules/projects/services/projects';

export default {
  async createProject (proj) {
    // proj object MUST have division value set in order to correctly generate a project number
    // proj must also have the related project_detail object (snow/irrigation, etc)
    proj.number = projectServices.generateProjectNumber(proj)
    return axios.post(endpoints.projects, proj).then((response) => {
      return response.data
    })
  },
  async getProject (projectID) {
    return axios.get(endpoints.projects + projectID + '/').then((response) => {
      return response.data
    })
  },
  async getProjectTimesheetDetails (projectID) {
    return axios.get(endpoints.projectDetails + '?project=' + projectID).then((response) => {
      return response.data
    })
  },
  async updateProject (project) {
    delete project.files // bandaid for files issues - MJ (since an older files array may overwrite recently attached files on project edit/save)
    return axios.patch(endpoints.projects + project.id + '/', project).then((response) => {
      return response.data;
    }).catch(err => {
      console.log(err.response.data);
    })
  },
  async addFileToProject (id, fileId) {
    return axios.post(endpoints.projects + id + '/add_file/', { 'file_id': fileId }).then((response) => {
      return response.data
    })
  },
  async getDivisionProjects (div) {
    // returns all projects filtered by division.
    // `div` passed in is a full `division` object
    return axios.get(endpoints.projects + '?division=' + div.id).then((response) => {
      return response.data
    })
  },


  // ------ Outstanding Service Issues
  async getProjectOutstandingServiceForWO (projectID) {
    return axios.get(endpoints.outstandingService + '?project=' + projectID + '&is_complete=false').then((response) => {
      return response.data
    })
  },
  async getProjectOutstandingService (projectID) {
    return axios.get(endpoints.outstandingService + '?project=' + projectID).then((response) => {
      return response.data
    })
  },
  async addProjectOutstandingService (payload) {
    return axios.post(endpoints.outstandingService, payload).then((response) => {
      return response.data
    })
  },
  async updateProjectOutstandingService (payload) {
    return axios.patch(endpoints.outstandingService + payload.id + '/', payload).then((response) => {
      return response.data
    })
  },
  async removeProjectOutstandingService (payload) {
    return axios.delete(endpoints.outstandingService + payload.id + '/').then((response) => {
      return response.data
    })
  },


  // ----- Stickies
  async getProjectStickies (projectID) {
    return axios.get(endpoints.stickies + '?project=' + projectID).then((response) => {
      return response.data
    })
  },
  async addProjectSticky (payload) {
    return axios.post(endpoints.stickies, payload).then((response) => {
      return response.data
    })
  },
  async updateProjectSticky (payload) {
    return axios.patch(endpoints.stickies + payload.id + '/', payload).then((response) => {
      return response.data
    })
  },
  async removeProjectSticky (payload) {
    return axios.delete(endpoints.stickies + payload.id + '/').then((response) => {
      return response.data
    })
  },




  // -------  Timesheets related
  async addProjectTimesheetDetail (obj) {
    return axios.post(endpoints.projectDetails, obj).then((response) => {
      return response.data
    })
  },
  async removeProjectTimesheetDetail (obj) {
    return axios.delete(endpoints.projectDetails + obj.id + '/').then((response) => {
      return response.data
    })
  },


  // --------  Routing
  async getProjectsForRouteGroups (divisionID, showStatus = false) {
    return axios.get(endpoints.projectsByRouteGroup + '?division='+ divisionID + '&show_status=' + showStatus).then((response) => {
      return response.data
    })
  },
  async getProjectRouteGroups (divisionID) {
    // projects are not attached
    return axios.get(endpoints.projectGroupings + '?division='+ divisionID).then((response) => {
      return response.data
    })
  },

  async getProjectRouteGroup (objID) {
    // projects are attached
    return axios.get(endpoints.projectGroupings + objID + '/field_crew/').then((response) => {
      console.log(JSON.parse(JSON.stringify(response.data)));
      return response.data
    })
  },
  async createProjectRouteGroup (obj) {
    return axios.post(endpoints.projectGroupings, obj).then((response) => {
      return response.data
    })
  },
  async updateProjectRouteGroup (obj) {
    return axios.patch(endpoints.projectGroupings + obj.id + '/', obj).then((response) => {
      return response.data
    })
  },
  async removeProjectRouteGroup (obj) {
    return axios.delete(endpoints.projectGroupings + obj.id + '/').then((response) => {
      return response.data
    })
  },

  async updateProjectGrouping (groupUpdateArray) {
    return axios.post(endpoints.projectGroupings + 'update_order/', groupUpdateArray).then((response) => {
      return response.data
    })
  },

  async createCrewVisitForProject (obj) {
    return axios.post(endpoints.crewVisits, obj).then((response) => {
      return response.data
    })
  },
  async getCrewVisitsForProject (projID) {
    return axios.get(endpoints.crewVisits + '?project=' + projID).then((response) => {
      return response.data
    })
  },
}
